(function () {
  'use strict';

  angular.module('app').component('confirmXmlStatusLabel', confirmXmlStatusLabel());

  function confirmXmlStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: ConfirmXmlStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  ConfirmXmlStatusLabelComponent.$inject = ['$translate'];

  function ConfirmXmlStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass = 'default';
      let statusTitle = 'CONFIRM_LATER';

      switch (vm.status) {
        case 'confirm_later':
          statusClass = 'default';
          statusTitle = 'CONFIRM_LATER';
          break;
        case 'accepted':
          statusClass = 'success';
          statusTitle = 'ACCEPTED';
          break;
        case 'accepted_partially':
          statusClass = 'warning';
          statusTitle = 'PARTIALLY_ACCEPTED';
          break;
        case 'rejected':
          statusClass = 'danger';
          statusTitle = 'REJECTED';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
